var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.183,
    height: 22.831,
    viewBox: "0 0 40.183 22.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M606.914,657.653a2.687,2.687,0,0,1-1.9-4.587l15.452-15.452-15.558-15.557a2.687,2.687,0,0,1,3.8-3.8l17.458,17.458a2.687,2.687,0,0,1,0,3.8l-17.352,17.352A2.678,2.678,0,0,1,606.914,657.653Z",
    transform: "translate(657.653 -604.122) rotate(90)",
    fill: "#f85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.90c676a7c712719738f210d48e52b26c.svg";
export { ForwardRef as ReactComponent };